export default __webpack_public_path__ + "static/media/noticeBgIcon.6ae8a452.png";